// Enum for document request detail tabs
export enum DocumentRequestTab {
  Overview = 'overview',
  Documents = 'documents',
  Comments = 'comments',
  History = 'history',
}

// Map tab names to indices
export const DOC_REQUEST_TAB_INDEX_MAP: Record<DocumentRequestTab, number> = {
  [DocumentRequestTab.Overview]: 0,
  [DocumentRequestTab.Documents]: 1,
  [DocumentRequestTab.Comments]: 2,
  [DocumentRequestTab.History]: 3,
};

// Map indices to tab names
export const DOC_REQUEST_INDEX_TAB_MAP: Record<number, DocumentRequestTab> = {
  0: DocumentRequestTab.Overview,
  1: DocumentRequestTab.Documents,
  2: DocumentRequestTab.Comments,
  3: DocumentRequestTab.History,
};
